import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Box,
  Chip,
  Stack,
} from "@mui/material";
import { CheckCircle, Cancel, InfoOutlined } from "@mui/icons-material";

const COLORS = {
  successSolid: "#1F7A4C",
  successGrad: "linear-gradient(135deg, #1F7A4C 0%, #2FB06C 100%)",
  errorSolid: "#C62828",
  errorGrad: "linear-gradient(135deg, #C62828 0%, #E53935 100%)",
  warnOkSolid: "#E67700",
  warnOkGrad: "linear-gradient(135deg, #E67700 0%, #FF9E2C 100%)",
  missingBg: "#FFF4CE",
  missingAccent: "#E6A700",
};

const AccesoPlantaCard = ({
  permitAccesoDelCamionAPlanta,
  documentosFaltantes,
}) => {
  const isPermitido = permitAccesoDelCamionAPlanta;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        width: "100vw",

        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          mb: 3,
          borderRadius: 3,
          boxShadow: 4,
          background:
            isPermitido && documentosFaltantes.length > 0
              ? COLORS.warnOkGrad
              : isPermitido
              ? COLORS.successGrad
              : COLORS.errorGrad,
          color: "white",
        }}
      >
        <CardContent sx={{ textAlign: "center", p: 3 }}>
          <Avatar
            sx={{
              bgcolor: "rgba(255,255,255,0.2)",
              width: 56,
              height: 56,
              mx: "auto",
              mb: 2,
            }}
          >
            {isPermitido ? (
              <CheckCircle sx={{ fontSize: 36, color: "#fff" }} />
            ) : (
              <Cancel sx={{ fontSize: 36, color: "#fff" }} />
            )}
          </Avatar>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            {isPermitido ? "Acceso Permitido" : "Acceso Denegado"}
          </Typography>

          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            {isPermitido
              ? "El camión puede ingresar a la planta."
              : "El camión no tiene permiso para ingresar."}
          </Typography>
        </CardContent>
      </Card>
      {documentosFaltantes.length !== 0 && (
        <Card
          sx={{
            mb: 3,
            borderRadius: 3,
            boxShadow: 4,
            background: COLORS.missingBg,
            color: "#111",
            border: `1px solid ${COLORS.missingAccent}`,
          }}
        >
          <CardContent sx={{ textAlign: "center", p: 3 }}>
            <Avatar
              sx={{
                bgcolor: COLORS.missingAccent,
                width: 56,
                height: 56,
                mx: "auto",
                mb: 2,
              }}
            >
              <InfoOutlined sx={{ fontSize: 36, color: "#fff" }} />
            </Avatar>

            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Revisar los siguientes documentos:
            </Typography>

            <br />
            {documentosFaltantes.length !== 0 ? (
              <>
                <Stack
                  direction="row"
                  spacing={1.5}
                   rowGap={1.5}   //para darle luz como dijo mica
                  flexWrap="wrap"
                  justifyContent="center"
                >
                  {documentosFaltantes.map((d) => (
                    <Chip
                      key={d.nombre}
                      label={d.nombre}
                      variant="filled"
                      icon={<InfoOutlined sx={{ fontSize: 18 }} />}
                      sx={{
                        mb: 1.5,
                        px: 1,
                        fontWeight: 500,
                        borderRadius: "8px",
                        bgcolor: "#FFF4CE", // fondo amarillo claro
                        color: "#111", // texto oscuro legible
                        border: "1px solid #E6A700", // acento
                        "& .MuiChip-icon": {
                          color: "#E6A700", // ícono en tono warning
                          ml: 0.5,
                        },
                        "&:hover": {
                          bgcolor: "#FFE88C",
                        },
                      }}
                    />
                  ))}
                </Stack>
              </>
            ) : null}
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default AccesoPlantaCard;

